<template>
  <div class="">

    <p class="pt-4" v-t="`product.single.choose_feature`"></p>
    <div>
      <!--   choose variation   -->
      <button class="m-1 btn"
              v-for="feature in productFeatureSubProduct(product)"
              :class="selectedVariation == feature.id ? 'variation-product-active' : 'variation-product-disable'"
              @click="selectVariation(product,feature)"
      >
        {{ productFeatureName(product, feature.id) }}
      </button>

      <!--   show price and quantity manager if price in not null   -->
      <div v-if="selectedVariation != null">
        <!-- show feature image  -->
        <img v-if="selectedVariationObject.image != null"
             class="product-feature-image"
             :src="subProductImage(product, selectedVariationObject.id)"
             :alt="productFeatureName(product, selectedVariationObject.id)">

        <div v-if="calculatePriceAndOffer(product, selectedVariationObject.id)['price'] != null">
          <!--   price and offer    -->
          <div class="my-3">
            <del v-if="calculatePriceAndOffer(product, selectedVariationObject.id)['offer'] > 0">
              <h3 class="m-auto text-muted"
                  v-html="$t('price.price', {currency: formatNumber(parseInt(calculatePriceAndOffer(product, selectedVariationObject.id)['price']))})">

              </h3>
            </del>
            <h2 class="m-auto"
                v-html="$t('price.price', {currency: formatNumber(parseInt(calculatePriceAndOffer(product, selectedVariationObject.id)['price'])  - calculatePriceAndOffer(product, selectedVariationObject.id)['offer'] )})">
            </h2>
          </div>

          <!--   quantity manager on authenticated shopping cart    -->
          <div v-if="checkProductOnShoppingCart(product,selectedVariationObject.id)">
            <m-shopping-cart-quantity-manager1 class=""

                                               :product="product"
                                               :sub_product="selectedVariationObject.id"/>
            <m-a :href="{name:shoppingCartLink()}">
              <button class="btn btn-primary rounded-pill" v-t="`product.single.shopping_cart`"></button>
            </m-a>
          </div>
          <!--   quantity manager on unauthenticated shopping cart    -->
          <div v-else>
            <div v-if="quantityChecker(1,product,selectedVariationObject.id)">

              <div class="my-2"
                   v-if="findAttributeOnSiteInfo('product_unit_warning')[0] >= findProductQuantity(product,selectedVariationObject.id) && findProductQuantity(product,selectedVariationObject.id) != 0">
                <!--  show warning when product reach his limit    -->
                <p v-html="$t('product.quantity_warning', {quantity: findProductQuantity(product, selectedVariationObject.id)})"></p>
              </div>


              <div class="">
                <div class="" v-if="isCartTypeOnUnAuthenticated()">
                  <button v-if="!checkProductOnShoppingCart(product,selectedVariationObject.id)"
                          @click="addToCartWrapper(product,selectedVariationObject.id)"
                          class="mt-4 btn rounded-pill row text-white btn-primary" v-t="`product.add_to_cart_physical`">
                  </button>
                </div>
                <div class="mt-3" v-else>
                  <m-a :href="{name:'Login'}">
                    <div class="btn btn-primary" v-t="`product.single.register_button`"></div>
                  </m-a>
                  <p v-t="`product.single.register_button_description`"></p>
                </div>
              </div>

            </div>
            <div
                v-else-if="findSubProductOnProduct(product,selectedVariationObject.id) && !quantityChecker(1,product,selectedVariationObject.id)">
              <div class="btn btn-secondary" v-t="`product.out_of_quantity`"></div>
            </div>
          </div>
        </div>
        <div v-else>
          <p class="h4 btn btn-primary rounded-pill my-3" v-t="`product.callText`"></p>
        </div>


      </div>


    </div>


  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {
  checkProductOnShoppingCart,
  shoppingCartFunctions
} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/ShoppingCartFunctions";
import {productFeatureName, productFeatureSubProduct} from '@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Product'
import mA from '../../Tags/A'
import mShoppingCartQuantityManager1 from '../ShoppingCartQuantityManager1'

export default {
  name: "VariationProduct",
  props: {
    product: {}
  },
  data() {
    return {
      selectedVariation: null,
      selectedVariationObject: {},
    }
  },
  components: {
    mA,
    mShoppingCartQuantityManager1,
  },
  computed: {
    ...mapGetters({
      isAuthenticated: 'User/isAuthenticated',
      order: "ShoppingCart/getSidebarBasketData",
    }),
  },
  methods: {
    checkProductOnShoppingCart,
    productFeatureName,
    ...shoppingCartFunctions,
    productFeatureSubProduct,
    selectVariation(product, feature) {
      this.selectedVariation = feature.id
      this.selectedVariationObject = feature
    },
    /* original */
    async addToCartWrapper() {
      // create this function to do some stuff after we add item to order
      await this.addToCart(...arguments)
      await this.refreshComponent()
    },
    refreshComponent() {
      this.$forceUpdate();
    },
    activeFirstVariationOfProduct() {
      let features = this.productFeatureSubProduct(this.product);

      for (const feature of features) {
        this.selectVariation(this.product, feature)
        break;
      }

    }
  },
  mounted() {
    window.addEventListener('click', this.refreshComponent);
    window.addEventListener('DOMContentLoaded', this.refreshComponent);
    this.activeFirstVariationOfProduct()
  },
}
</script>

<style scoped>
.product-feature-image {
  height: 350px;
  width: 100%;
  object-fit: contain;
  aspect-ratio: 1/1;
}

.variation-product-active, .variation-product-disable {
  border: 1px solid var(--primary);
}

.variation-product-active {
  background: var(--primary);

}
</style>